import { createStructuredSelector } from 'reselect';

import { fetchGAWState } from './LoadingPageSelectors';

export const selectRecentCharities = (state) => {
  const { recentCharities } = fetchGAWState(state);
  return recentCharities;
};

export const selectSavedCharities = (state) => {
  const { savedCharities } = fetchGAWState(state);
  return savedCharities;
};

export const selectGrantedCharityLoading = (state) => {
  const { grantedCharity } = fetchGAWState(state);
  if (grantedCharity && grantedCharity.isLoading) {
    return grantedCharity.isLoading;
  }
  return false;
};

export const selectSavedCharityLoading = (state) => {
  const { savedCharity } = fetchGAWState(state);
  if (savedCharity && savedCharity.isLoading) {
    return savedCharity.isLoading;
  }
  return false;
};

export const selectSearchCharityLoading = (state) => {
  const { searchCharity } = fetchGAWState(state);
  if (searchCharity && searchCharity.isLoading) {
    return searchCharity.isLoading;
  }
  return false;
};

export const selectSearchCharityData = (state) => {
  const { searchCharity } = fetchGAWState(state);
  if (searchCharity && searchCharity.data) {
    return searchCharity.data;
  }
  return [];
};

export const selectIsCharitySearch = (state) => {
  const { searchCharity } = fetchGAWState(state);
  if (searchCharity && searchCharity.isCharitySearch) {
    return searchCharity.isCharitySearch;
  }
  return false;
};

export const selectIsNew = (state) => {
  const { accountSelected } = fetchGAWState(state);
  if (accountSelected && accountSelected.isNew) {
    return accountSelected.isNew;
  }
  return false;
};

export const selectGrantHistory = (state) => {
  const { grantHistory } = fetchGAWState(state);
  return grantHistory;
};

export const selectPendingGrants = (state) => {
  const { pendingGrants } = fetchGAWState(state);
  return pendingGrants;
};

export const selectPendingActiveSchedule = (state) => {
  const { pendingActiveSchedule } = fetchGAWState(state);
  return pendingActiveSchedule;
};

export const selectGrantAgreementSearchTerm = (state) => {
  const { grantAgreementSearchTerm } = fetchGAWState(state);
  return grantAgreementSearchTerm;
};

export const selectGrantAgreementGeminiSearchTerm = (state) => {
  const { grantAgreementGeminiSearchTerm } = fetchGAWState(state);
  return grantAgreementGeminiSearchTerm;
};

export const selectSearchGeminiData = (state) => {
  const { searchGemini } = fetchGAWState(state);
  if (searchGemini && searchGemini.data) {
    return searchGemini.data;
  }
  return [];
};

export const selectIsGeminiSearch = (state) => {
  const { searchGemini } = fetchGAWState(state);
  if (searchGemini && searchGemini.isGeminiSearch) {
    return searchGemini.isGeminiSearch;
  }
  return false;
};

export const selectEdit = (state) => {
  const { edit } = fetchGAWState(state);
  return edit;
};

export const selectGuideStarSearchCount = (state) => {
  const { searchCharity } = fetchGAWState(state);
  if (searchCharity && searchCharity.guidestarSearchCount) {
    return searchCharity.guidestarSearchCount;
  }
};

export const selectScheduleHistory = (state) => {
  const { scheduleHistory } = fetchGAWState(state);
  return scheduleHistory;
};

export const selectAgreementHistory = (state) => {
  const { agreementHistory } = fetchGAWState(state);
  return agreementHistory;
};

export const selectPendingGrantsLoading = (state) => {
  const { pendingGrantsLoading } = fetchGAWState(state);
  return pendingGrantsLoading;
};

export const selectPendingGrantAgreement = (state) => {
  const { pendingGrantAgreement } = fetchGAWState(state);
  return pendingGrantAgreement;
};

export const selectGrantHistoryLoading = (state) => {
  const { grantHistoryLoading } = fetchGAWState(state);
  return grantHistoryLoading;
};

export const selectSearchGeminiStringResponse = (state) => {
  const { searchGemini } = fetchGAWState(state);
  if (searchGemini && searchGemini.searchGeminiStringResponse) {
    return searchGemini.searchGeminiStringResponse;
  }
};

export const selectServerDown = (state) => {
  const { searchCharity } = fetchGAWState(state);
  return searchCharity.serverDown;
}

export const charityDerivedStates = createStructuredSelector({
  recentGrants: selectRecentCharities,
  savedCharities: selectSavedCharities,
  isLoadingGranted: selectGrantedCharityLoading,
  isLoadingSaved: selectSavedCharityLoading,
  isLoadingCharity: selectSearchCharityLoading,
  searchCharity: selectSearchCharityData,
  isCharitySearch: selectIsCharitySearch,
  isNewAccount: selectIsNew,
  grantHistory: selectGrantHistory,
  pendingGrants: selectPendingGrants,
  pendingActiveSchedule: selectPendingActiveSchedule,
  grantAgreementSearchTerm: selectGrantAgreementSearchTerm,
  grantAgreementGeminiSearchTerm: selectGrantAgreementGeminiSearchTerm,
  searchGeminiData: selectSearchGeminiData,
  isGeminiSearch: selectIsGeminiSearch,
  editMode: selectEdit,
  guidestarSearchCount: selectGuideStarSearchCount,
  scheduleHistory: selectScheduleHistory,
  agreementHistory: selectAgreementHistory,
  pendingGrantsLoading: selectPendingGrantsLoading,
  pendingGrantAgreement: selectPendingGrantAgreement,
  grantHistoryLoading: selectGrantHistoryLoading,
  searchGeminiStringResponse: selectSearchGeminiStringResponse,
  serverDown: selectServerDown
});
